<template>
  <div class="w-100">
    <ul>
      <li
        v-for="tab in tabsArray"
        :key="tab.id"
        @click="onTabClick(tab.id)"
        :class="{active:tab.id === currentTab}"
      >{{tab.name}}</li>
    </ul>

    <slot name="subheader"></slot>
    
    <div v-for="tab in tabsArray" :key="tab.id" v-show="tab.id === currentTab">
      <slot :name="'tab-'+tab.id"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "cmsButtonGroup",
  props: ["tabs"],
  data() {
    return {
      currentTab: 0
    };
  },
  computed: {
    tabsArray: vm =>
      vm.tabs.split(",").map((t, i) => {
        return { id: i, name: t };
      })
  },
  methods: {
    onTabClick(tabId) {
      this.$data.currentTab = tabId;
    }
  }
};
</script>

<style scoped lang="scss">
ul {
  list-style: none;
  margin: 0.5rem auto;
  padding: 0;
}

li {
  padding: 0.4rem 0.8rem 0.3rem 0.8rem;
  border-width: 1px 0 1px 1px;
  border-style: solid;
  border-color: $bluish-color;
  display: inline-block;
  font-size: 0.83rem;

  &.active {
    background-color: $bluish-color;
    color: white;
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  }

  &:not(.active) {
    color: $bluish-color;
  }

  &:first-child {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  &:last-child {
    border-right-width: 1px;
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
}
</style>